// Regex Resources

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i
export const uppercaseCharacterRegex = /[A-Z]+/
export const lowercaseCharacterRegex = /[a-z]+/
export const numberRegex = /[0-9]+/
export const whitespaceRegex = /\s+/
export const specialCharacterRegex = /[\!"#\$%\&'\(\)\*\+-\.\/:;<=>\?@\[\\\]\^_`{\|}~]+/
